<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe"/>
          Token
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-1">#</div>
            <div class="col-lg-2">{{$t('createTime')}}</div>
            <div class="col-lg-7">Token</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="(item, index) in items" :key="item._id">
            <div class="col-lg-1">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="col-lg-2">
              <span>{{ item.createTime | moment('DD/MM/YY HH:mm:ss') }}</span>
            </div>
            <div class="col-lg-7">
              <b class="c-smart-table__label">Token: </b>
              <span>{{ item.token.substring(0,80) }}...</span>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button type="button" v-clipboard:copy="item.token" v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="copy"/>&nbsp;{{ $t('copy') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>
<script>
import List from '../mixins/List';
import CRUD from "../mixins/CRUD";

export default {
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/token',
      autoLoad: true
    }
  },
  methods: {
    create() {
      let loader = this.$loading.show();
      this.$service({url: this.service, method: 'post'}).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('created'),
            icon: 'success'
          });
          this.load();
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('createFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
      });
    },
    onCopy() {
      this.$swal({
        text: this.$t('tokenCopied'),
        icon: 'success',
        toast: true,
        position: 'top-end',
        timer: 5000,
      });
    },
    onError() {
      this.$swal({
        title: this.$t('error'),
        text: this.$t('copyFailed'),
        icon: 'error'
      });
    },
  },
  i18n: {
    messages: {
      en: {
        copy: "Copy",
        tokenCopied: "Token copied!",
        copyFailed: "Fail to copy token"
      },
      vi: {
        copy: "Sao chép",
        tokenCopied: "Token đã được sao chép!",
        copyFailed: "Thất bại trong việc sao chép token"
      }
    }
  }
}
</script>